import { render, staticRenderFns } from "./ComponentWrapper.vue?vue&type=template&id=3c727e69&scoped=true"
import script from "./ComponentWrapper.vue?vue&type=script&lang=js"
export * from "./ComponentWrapper.vue?vue&type=script&lang=js"
import style0 from "./ComponentWrapper.vue?vue&type=style&index=0&id=3c727e69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c727e69",
  null
  
)

export default component.exports